<template>
  <el-container class="body_container">
    <el-header style="height: 100px;padding:0px">
      <el-row class="body_title">学分  (通过输入“姓名/执业证号/律所”查询)</el-row>
      <el-form v-model="searchVo" :inline="true" ref="search">
        <el-row type="flex">
          <el-col>
            <el-form-item  label-width="40px"  size="small">
              <el-input v-model="searchVo.keyword" placeholder="姓名/执业证号/律所"  style="width: 160px">
                <el-button  @click="search" icon="el-icon-search"></el-button>
              </el-input>
            </el-form-item>
            <el-form-item  label-width="40px"  size="small" >
              <el-select v-model="year" placeholder="学年" @change="changeYear" style="width: 100px">
                <el-option label="去年" value="last"></el-option>
                <el-option label="前年" value="before"></el-option>
              </el-select>
              <el-date-picker
                v-model="dateValue"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
              <!--<el-date-picker-->
                <!--style="width: 150px"-->
                <!--v-model="searchVo.startTime"-->
                <!--type="date"-->
                <!--value-format="yyyy-MM-dd"-->
                <!--placeholder="选择开始日期">-->
              <!--</el-date-picker>-->
              <!--<el-date-picker-->
                <!--style="width: 150px"-->
                <!--v-model="searchVo.endTime"-->
                <!--value-format="yyyy-MM-dd"-->
                <!--type="date"-->
                <!--placeholder="选择结束时间">-->
              <!--</el-date-picker>-->
            </el-form-item>
            <el-form-item class="dialog-footer" >
              <el-button type="primary" @click="search">查询</el-button>
              <el-button @click="resetForm('search')" style="background-color: #fff;border: 1px solid #3e64ff;color: #3e64ff;padding: 7px 12px">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-header>
    <el-main class="search_result">
      <el-table :data="periods.list" v-loading="loading">
        <el-table-column prop="lawyerName" label="律师名称" min-width="90px"></el-table-column>
        <el-table-column prop="code" label="执业证号" min-width="175px"></el-table-column>
        <el-table-column prop="assName" label="律协名称" min-width="120px"></el-table-column>
        <el-table-column prop="office" :show-overflow-tooltip="true" label="律所名称" min-width="130px"></el-table-column>
        <el-table-column prop="totalTime" :show-overflow-tooltip="true" label="总时长(秒)" min-width="80px"></el-table-column>
        <el-table-column prop="totalScore" sortable label="总分" min-width="70px"></el-table-column>
        <el-table-column prop="liveTime" label="直播时长" min-width="90px"></el-table-column>
        <el-table-column prop="historyTime" label="历史直播时长" min-width="115px"></el-table-column>
        <el-table-column prop="coursewareTime" label="课件时长" min-width="90px"></el-table-column>
        <el-table-column prop="lawyerId" label="学习记录" width="90px">
          <template slot-scope="scope">
            <i class="el-icon-more" @click="checkPeriod(scope.row)"  style="font-size: 16px;color: #666;cursor: pointer"></i>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-pagination class="page"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :page-size="periods.rows"
                   :current-page="periods.page"
                   layout="prev, pager, next, jumper"
                   :total="periods.total">
    </el-pagination>
  </el-container>
</template>

<script>
  import period from '@/api/period'
  import store from '../../store/index'
  export default {
    name: 'Period',
    data () {
      return {
        globalAssId: null,
        dateValue: '',
        value: true,
        lawyerId: null,
        loading: false,
        addLawyerVisible: false,
        periods: {
          page: 1,
          rows: 10,
          total: 0,
          list: []
        },
        year: null,
        month: null,
        day: null,
        searchVo: {
          startTime: '',
          endTime: '',
          keyword: ''
        },
        value2: '1',
        type: 'H',
        page: 1,
        size: 15
      }
    },
    methods: {
      checkPeriod (row) {
        this.$router.push({
          path: '/lawyer/record',
          query: {
            lawyerId: row.lawyerId
          }
        })
      },
      handleSizeChange (val) {
        // console.log(`每页 ${val} 条`)
      },
      handleCurrentChange (val) {
        // console.log(`当前页: ${val}`)
        this.page = val
        this.reload()
      },
      reload () {
        this.loading = true
        this.searchVo.startTime = this.dateValue[0]
        this.searchVo.endTime = this.dateValue[1]
        period.start({page: this.page, rows: this.size, startTime: this.searchVo.startTime, endTime: this.searchVo.endTime, assId: this.globalAssId, keyword: this.searchVo.keyword}).then(res => {
          this.periods = res.data.data
          this.loading = false
          // console.log(this.periods)
        })
      },
      search () {
        this.page = 1
        this.reload()
      },
      // 重置form
      resetForm () {
        this.searchVo.startTime = ''
        this.searchVo.endTime = ''
        this.searchVo.keyword = ''
        this.dateValue = ''
        this.year = null
        this.periods ={
          page: 1,
          rows: 10,
          total: 0,
          list: []
        }
        // this.reload()
      },
      updateData (val) {
        this.page = val
        this.reload()
      },
      dateBiJiao (firstDate, lastDate) {
        var arr = firstDate.split("-");
        var firsttime = new Date(arr[0], arr[1], arr[2]);
        var firsttimes = firsttime.getTime();

        var arrs = lastDate.split("-");
        var  lasttime = new Date(arrs[0], arrs[1], arrs[2]);
        var  lasttimes =  lasttime.getTime();

        if (firsttimes>= lasttimes) {
          return true;
        }
        else
          return false;
      },
      changeYear (values) {
        var date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth()+1;
        const day = date.getDate();
        // 上一年周期
        if (values === 'last') {
          // 如果该日期比当前日期晚 this > month，则以该日期为终点，上一年该日期为起点，为一个年度。
          // 2019,06.01 -2020.06.01
          if (this.dateBiJiao((year + '-' + this.month + '-' + this.day),(year + '-' + month + '-' + day))) {
            this.searchVo.startTime =  year-2 + '-' + this.month + '-' + this.day //'2018.06.01'
            this.searchVo.endTime =  year-1 + '-' + this.month + '-' + this.day //'2019.06.01'
            this.dateValue = [this.searchVo.startTime,this.searchVo.endTime]
            // 如果该日期比当前日期早，则以该日期为起点，下一年该日期为终点，为一个年度。
            // 2020,05.01 -2021.05.01
          } else{
            this.searchVo.startTime =  year-1 + '-' + this.month + '-' + this.day //'2019.05.01'
            this.searchVo.endTime = year + '-' + this.month + '-' + this.day //'2020.05.01'
            this.dateValue = [this.searchVo.startTime,this.searchVo.endTime]
          }
        }
        // 上上周期
        if (values === 'before') {
          // 如果该日期比当前日期晚 this > month，则以该日期为终点，上一年该日期为起点，为一个年度。
          // 2019,06.01 -2020.06.01
          if (this.dateBiJiao((year + '-' + this.month + '-' + this.day),(year + '-' + month + '-' + day))) {
            this.searchVo.startTime =  year-3 + '-' + this.month + '-' + this.day //'2017.06.01'
            this.searchVo.endTime =  year-2 + '-' + this.month + '-' + this.day //'2018.06.01'
            this.dateValue = [this.searchVo.startTime,this.searchVo.endTime]
            // 如果该日期比当前日期早，则以该日期为起点，下一年该日期为终点，为一个年度。
            // 2020,05.01 -2021.05.01
          } else {
            this.searchVo.startTime =  year-2 + '-' + this.month + '-' + this.day //'2018.05.01'
            this.searchVo.endTime = year-1 + '-' + this.month + '-' + this.day //'2019.05.01'
            this.dateValue = [this.searchVo.startTime,this.searchVo.endTime]
          }
        }
      }
    },
    created () {
      period.findTimeNode().then(res => {
        this.month = parseInt(res.data.data[0].month)
        this.day = parseInt(res.data.data[0].day)
      })
      if (store.getters.getAsId === '') {
        this.globalAssId = null
      }else {
        this.globalAssId = store.getters.getAsId
      }
      // console.log(this.globalAssId)
      // this.reload()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/lawyer/Credit.vue